/* eslint-disable quotes */
export default {
  go_to_add: 'Go to Add',
  tips: 'Tips',
  title_no_env_desc: "This title doesn't have any environment yet.",
  has_been_opened: 'has been opened',
  click_btn_view_server:
    'You can click the button below to view and use the service in the pop-up window',
  get_started: 'Get Started',
  create_new_env: 'Create New Environment',
  create_new_title: 'Creat New Title',
  copy_clipboard: 'Copied to clipboard.',
  access_restricted_desc:
    'Access restricted. You do not have rights to operate',
  env_add_success: 'Environment added successfully.',
  env_add_fail: 'Failed to add environment.',
  env_name_required: 'Environment name is required.',
  max_64: 'Maximum 64 characters.',
  only_letters_numbers:
    'You can enter letters, numbers, underscores (_), and dashes (-).',
  name_exists_tips: 'The name already exists.',
  env_type: 'Environment Type',
  environment_name: 'Environment Name',
  add_environment: 'Add Environment',
  edit_environment: 'Edit Environment',
  delete_title: 'Delete Title',
  to_provide: 'to provide.',
  env_table_id: 'ID',
  env_table_name: 'Name',
  select_your_region: 'Please select your main site',
  env_type_required: 'Environment Type is required.',
  select_your_env_type: 'Please select your environment type',
  support_dev_desc:
    'Currently only supports the DEV environment. The LIVE environment needs detailed requirements. Please ',
  enter_environment_name: 'Please enter the environment name',
  enter_environment_desc: 'Please enter the description',
  env_del_success: 'Environment deleted successfully.',
  env_not_exist: 'The environment to be deleted does not exist.',
  env_del_fail: 'Environment delete failed.',
  migrate_game_confirm_has_service_desc:
    'Services have been initiated in the environment: {{name}}.\nDo you confirm the deletion of this environment? The operation cannot be recovered.',
  migrate_game_confirm_desc:
    'Are you sure you want to delete the environment: {{name}}?',
  del_environment: 'Delete Environment',
  game_deleted_success_message:
    '{{gameName}} has been deleted successfully! It will take a moment for the data to be deleted in all services.',
  sure_del_title_desc: 'Are you sure you want to delete the title: ',
  sure_del_title_permanently_desc:
    'This will permanently delete the title and all associated environment, configuration and data.',
  name_result_can_up_128:
    'The name of the result and can up to 128 characters, including letters,numbers and underscores.',
  // 同步：
  check_env: 'Check Evn',
  continue_anyway: 'Do you want to continue anyway?',
  lower_version_upgrade_desc:
    'The version of the target environment you have selected is lower than the original environment version, you need to complete the upgrade of the target environment (upgrade to the same version as the original) before synchronisation.',
  continue: 'Continue',
  config_sync: 'Config Sync',
  being_sync_desc: 'The configuration is being synced.',
  not_close_desc: 'Please wait and do not close or refresh the page.',
  sync_success:
    'Congratulations! The environment synchronisation has been completed.',
  sync_fail: 'The sync operation has failed, please try again.',
  sync_fail_contact: 'The sync operation has failed, contact the developer.',
  operation_conflict_target:
    'Operation conflict. A task is being executed at target env.',
  operation_conflict_org:
    'Operation conflict. A task is being executed on the original env.',
  service_upgrade: 'Service Upgrade',
  upgrade_fail: 'The upgrade operation has failed, please try again.',
  env_check_progress: 'The environment Check in progress.',
  env_check: 'Environment Check',
  synchronisation_failure: 'Synchronisation Failure',
  higher_version_failure_desc:
    'The version of the target environment you have selected is higher than the original environment version, you need to complete the upgrade of the original environment (upgrade to the same version as the target environment) before synchronisation.',
  missing_necessary_failure_desc:
    'Internal Error, Missing necessary data or configuration. Please contact us.',
  environment_sync: 'Environment Sync',
  view_environment_sync_task: 'View Environment Sync Task',
  view_sync_task: 'View Sync Task',
  full_replace: 'Full Replace',
  add_on: 'Add - on',
  no_valid_service_version:
    'No valid service version detected (possible reasons: current environment has no active services or activated services do not support environment synchronization). Synchronization cannot be completed. Please select another environment with active services or contact us enable services and try again.',
  detected_incompatible_service_version:
    'Detected incompatible environment service versions, synchronization cannot be completed. Please select another environment or contact us to upgrade the version and try again.',
  service_version_error: 'Error',
  ds_sync_tips: 'Only involves Fleet Template configuration.',
  sync_method: 'Sync Method',
  sync_method_desc:
    'The current sync method only supports full-replace. All configurations of selected services in the original environment will overwrite those in the target environment.If there are correlation relationships within the configuration, the related content will be synchronized as well.',
  go_view: 'Go to view',
  task_submit_success: 'Task submitted successfully',
  task_submit_success_tips:
    'The environment synchronization task is submitted successfully. You can go to the task module to view details.',
  env_sync_confirm_tips:
    'The environment synchronization task is submitted successfully, you can go to the environment synchronization operation Are you sure? This task cannot be undone or rolled back after it is generated.',
  sync_environment: 'Sync Environment',
  no_services_synced: 'No services can be synced',
  select_env: 'Select Environment',
  sync_config: 'Sync Config',
  org_env: 'Original Env',
  tar_env: 'Target Env',
  select_services: 'Select Services',
  select_one_service: 'Please select at least one service',
  services_already_started_desc:
    'Data synchronisation is only supported for services that exist in both the original and target environments.',
  being_sync_not_close_page:
    'The configuration is being synced, please do not close or refresh the page.',
  configuration_not_currently_services:
    '1. Configuration synchronisation is not currently allowed for individual services.',
  build_packages_sync: '2. Build packages are out of scope for this sync.',
  verify_services_activated_both_desc:
    'Please verify that the corresponding services have been activated in both the original and target environments.',
  sync: 'Sync',
  edit_title_name_success: 'Edit title name success!',
  edit_title_name_fail: 'Edit title name failed!',
  delete_title_desc:
    'This will permanently delete the title and all associated environment, configuration and data.',
  up_to_10_env: 'Up to 10 environments under the title.',
  up_to_30_env: 'Up to 30 environments under the title.',
  key: 'Key',
  value: 'Value',
  title_key: 'Title Key',
  after_service_activated_desc:
    'After the service is activated, the field is automatically generated and displayed',
  game_no_env_choose_again:
    'This game no longer has an environment, please choose again.',
  basic: 'Basic',
  // features: 'Features',
  env_length: 'Environments({{envListLength}})',
  title_overview: 'TITLE OVERVIEW',
  all_product: 'All Product',
  product_category: 'Product categories',
  shortcuts: 'Shortcuts',
  request_fail_no_permission:
    'The request failed, possibly because there is no such permission or a service error.',
  game_not_env_tips:
    'The current game does not have an environment, please create an environment.',
  remove_favorites_success:
    'The service has been successfully removed from favorites.',
  add_favorites_success:
    'The service has been successfully added to favorites.',
  fail_application: 'Failed application, no service selected.',
  is_applying: ' is applying',
  is_opened: ' is opened',
  application_success:
    'The application has been successfully sent, please wait patiently.',
  select_service_apply_for: 'Please select the service you want to apply for.',
  are_you_sure_apply_service: 'Are you sure you want to apply the service?',
  sure_apply_this_service_desc:
    'Are you sure you want to apply to activate this service?',
  sure_apply_num_service_desc:
    'Are you sure you want to apply to activate these {{num}} services?',
  services: 'Services',
  all_services_available: 'All services are available',
  batch_apply: 'Batch Apply',
  more: 'more',
  received_application_24_hours:
    'InGame has received the application and will complete the review within 48 hours.',
  service_close_tips:
    'The service has been suspended. If you have any questions, please contact the InGame team.',
  apply_to_start: 'Apply to Start',
  ready_to_access: 'Ready to access',
  application_already_sent: 'Application has already been sent ({{services}}).',
  service_not_exist: 'Service does not exist.',
  apply_service_fail: 'Apply service failed!',
  company_not_valid: 'Incomplete enterprise certification',
  application_sent_success: 'Application sent successfully.',
  please_select_the_env: 'Please select the Environment!',
  apply_service: 'Apply Service',
  latest_release: 'Latest Release: January 17, 2025.',
  latest_version: 'Latest Version: V1.7.0',
  start_now: 'Start Now',
  documentation: 'Documentation',
  most_popular: 'Most Popular',
  new_release: 'New Release',
  step_check_env_desc:
    'For each title, there is at least one environment. To simplify the process, we have created a test environment for you. Please review all configuration settings related to the environment, as these parameters need to be entered into the SDK. Note: The address parameters will only be available once the service has been successfully activated.',
  check: 'Check',
  step_apply_service_desc:
    "You can now apply to activate any service you're interested in trying. You will receive feedback on your application within 48 hours.",
  step_sdk_contact_desc:
    'The InGame platform offers a comprehensive SDK and a sample demo . You can download the SDK directly or use our sample demo to quickly understand the service features. By integrating with InGame services now, you can also obtain the source code of the sample demo, enhancing your integration efficiency.',
  contact_us_upper: 'Contact Us',
  go_to_download: 'Go to Download',
  step_obtain_configuration_information_desc:
    "When downloading from our platform, the InGameSDK will seamlessly integrate the title environment's configuration details. For additional parameters, feel free to navigate to the title settings interface.",
  get: 'View Config',
  step_questions_contact_desc:
    "You've completed the basic setup for InGame. Now you can experience the full range of our platform's services. If you encounter any questions or have suggestions while using our services, please feel free to reach out to us anytime. We're here to help!",
  step_launched_help_desc:
    "If your game is getting ready for release, please get in touch with us. We'll provide you with ample resources and expert team support to assist you in completing the pre-launch preparation process smoothly.",
  in_game_focus_on: 'InGame services make you focus on ',
  innovation: 'innovation',
  check_environment: 'Check Environment',
  sdk_download: 'SDK Download',
  get_configuration: 'Get Configuration',
  testing: 'Testing',
  go_live: 'Go Live',
  title_access_failed: 'The Title Access Failed.',
  devcloud_tips:
    'This service is currently not supported in the DevCloud environment. If you are interested in this service, please contact us to switch to an alternative environment for the experience.',
  novice_guide_btn: 'Got it',
  gamemode_desc:
    'Gamemode refers to the game mode, which is used to host different game-play configurations. It can participate in the calculation of matching rules in the Matchmaking service. In the DS Hosting service, it can be used to identify DS clusters running different game-play. Servers will use this configuration to indicate the type of DS they wish to allocate.',
  party_desc:
    'Party is the team-forming service. It provides a temporary binding relationship among players. Through this service, temporary squads can be created in the game. It supports players to search and join, send invitations, request to join, and join via external link sharing.',
  lobby_desc:
    'Lobby service provides players with a temporary gathering place. Players can directly create lobbies through this service. It also supports the Party service to create and join Lobbies after going through the matching process. Meanwhile, Lobby manages the game battle information within the lobby, realizing operations such as initiating battle DS, settlement, and synchronizing the information of joining DS in the middle of the game.',
  customtag_desc:
    'Custom Tags are mainly used in the battle module and DS service, serving as the configuration for derivative rules other than the conventional logic of matching battles. This Tag is a custom tag associated with requests. It can be used for configuring hard rules in the matching service and also for the DS service to calculate the zone result through this field and then specify and select different DSCs to initiate.',
  please_select_open_service:
    'Please select the services under {{service}} that you wish to activate (multiple selections allowed).',
  automatically_open_service:
    'The {{service}} service needs to be used in conjunction with {{relevanceService}}, so this service will be activated automatically.',
  apply_next_btn: 'Next',
  apply_submit_btn: 'Submit',
  apply_back_btn: 'Previous',
  ingame_operation_tips:
    'This service is an additional InGame operation and cannot be used independently. Ensure that related services that need to be executed have been added',
  whether_name_unique_label: 'Is the player display name unique?',
  whether_query_by_name_label:
    'Do you need to support player display name search?',
  friend_type_label: 'The types of friends in the game are:',
  account_friends: 'In-game Account Friend',
  character_friends: 'In-game Player Friend',
  qps_label: 'Estimated Maximum QPS',
  service_confirmation: 'Service Confirmation',
  information_filling: 'Information Submission',
  submit_applications: 'Submit Application',
  apply_complete_btn: 'Done',
  apply_title: 'Application for {{service}} Service',
  apply_submit_tips:
    'We have received your application for the {{service}} Service.InGame will complete the review within 48 hours.',
  puffer_apply_region: 'Service Region',
  puffer_apply_southeast: 'Asia Pacific (Southeast) Region',
  puffer_apply_japan: 'Asia Pacific（Japan） Region',
  puffer_apply_korea: 'Asia Pacific（Korea）Region',
  puffer_apply_europe: 'Europe Region',
  puffer_apply_eastern: 'Eastern North America Region',
  puffer_apply_western: 'Western North America Region',
  puffer_apply_south: 'South America Region',
  puffer_apply_singapore: 'InGame-Singapore Region',
  qps_placeholder: 'Please enter the Estimated Maximum QPS value.',
  can_not_apply_in_live:
    'This service cannot be activated in a live environment',
  dmp_confirm_open_live:
    'Enable {{service}} in LIVE? Charges will apply, DEV access disabled (data kept)',
  dmp_nonsupport_open_dev:
    '{{service}} has been activated in LIVE environment and cannot be enabled in DEV',
  services_status_opened: 'Opened',
  services_status_closed: 'Closed',
  services_status_geo: 'Opened (GEO Restriction)',
  services_status_white: 'Opened (Whitelist Access)',
  services_status_tips_opened: 'Server will open at {{time}}(UTC0)',
  services_status_tips_closed: 'Server will close at {{time}}(UTC0)',
  services_status_tips_switch:
    'The server opening type is scheduled to be switched at {{time}}(UTC0)',
  view_plan: 'View Plan',
  cancel_task: 'Cancel Task',
  open_type: 'Open Type',
  service_open: 'Open',
  service_close: 'Close',
  service_open_task: 'Open task submit',
  service_close_task: 'Close task submit',
  drawer_open_tips:
    'Once the corresponding server launch type is selected, it cannot be changed. Please operate with caution.',
  drawer_open_type_tips:
    'Once the corresponding server launch type is selected, restrictions will be imposed according to the selected type after the server is launched. Please operate with caution.',
  drawer_close_tips:
    'Once the server shutdown process is initiated, players will not be able to log in. Please operate with caution.',
  drawer_env_info: 'Environment Info',
  switch_open_type: 'Switch Open Type',
  open_time: 'Open Time(UTC0)',
  close_time: 'Close Time(UTC0)',
  time_instant: 'Instant',
  time_scheduled: 'Scheduled',
  full_public_access: 'Full Public Access',
  whitelist_access: 'Whitelist Access',
  gro_restriction: 'GEO Restriction',
  view_whitelist: 'View Whitelist',
  task_status: 'Task Status',
  cancellation_confirmation: 'Cancellation Confirmation',
  cancellation_confirmation_tips:
    'The server opening task has been successfully set. Do you confirm the cancellation of this task?',
  close_confirmation: 'Server Shutdown Confirmation',
  close_confirmation_tips:
    'Do you confirm to submit the server shutdown task? If the server shutdown task starts to be executed, it will prevent players from logging in, and the task will enter a 10-minute warm-up phase before execution. During this warm-up phase, the task cannot be canceled.',
  open_confirmation: 'Server Startup Confirmation',
  open_confirmation_tips:
    'Do you confirm to submit the server opening task? If the server opening task starts to be executed, access restrictions will be applied according to the default server open type, and the task will enter a 10-minute warm-up phase before execution. During this warm-up phase, the task cannot be canceled.',
  view_opening_task: 'View Openting Task',
  view_shutdown_task: 'View Shutdown Task',
  view_task: 'View Task',
  no_change_disabled:
    'No change in server launch type is allowed, and submission cannot be made.',
  version_too_low: 'The version is too low to support this function.',
  not_privacy_access:
    'The Privacy Access service is not enabled and cannot be configured.',
  task_cannot_cancel:
    'This task is already in progress and cannot be canceled.',
  season_sync_tip: 'The BattlePass depends on the Season module.',
  gamemode_sync_tip:
    'The Matchmaker and SkillRating depends on the Gamemode module.',
  factionset_sync_tip:
    'The Matchmaker and SkillRating and Gamemode depends on the FactionSet module.',
  coupled_with: 'Coupled with {{serviceName}}',
  coupling_tips:
    'Due to the coupling relationship among some services, when such services are selected, other services that are coupled with them will also be automatically selected and activated.',
  service_selection: 'service selection',
  service_application_tips:
    'This service is currently under application. Please wait patiently.',
  exit_apply_tips:
    'Are you sure you want to exit the InGame service application?',
  exit_apply: 'Exit Batch Apply',
  select_apply_service: 'The services that have been selected for activation：',
  related_matters_fill: 'Information Filling for Related Matters：',
  batch_apply_submit_tips:
    'We have received your service application.InGame will complete the review within 48 hours.',
  not_support_dmp:
    'This service does not currently support batch applications. Please go to the service interface to submit applications individually.',
  game_code_exists: 'The code name already exists and cannot be created.',
  client_api_control: 'Client API Control',
  client_api: 'Client API',
  interface_description: 'Interface Description',
  permission_status: 'Permission Status',
  last_modified_by: 'Last Modified By',
  last_modified_time: 'Last Modified Time',
  unpublished_changes: 'Unpublished changes.',
  discard_all: 'Discard all',
  api_publish: 'Publish',
  discard_changes: 'Discard Changes',
  discard_changes_tips:
    'You have unsaved changes. Are you sure you want to discard all changes?',
  api_cannot_be_disabled: 'This API cannot be disabled.',
  no_configurations_tips:
    'Due to the unavailability of the {{serviceName}} service, you currently have no configurations.',
  go_to_apply: 'Go to apply',
  finally_released: 'Last Published：',
  client_preview: 'Preview',
  client_preview_tips: 'Compare with the previous version',
  client_publish: 'Publish',
  client_publish_tips: 'Submit new version',
  proceed_caution_tips:
    'Disabled APIs will break client calls after publish, potentially impacting online services. Proceed with caution.',
  version_info: 'Version Information',
  version_name_tips:
    'The name for this new version can contain up to 128 characters, including letters, numbers, and underscores, and must start with a letter. The default value is the time of publication.',
  version_desc_tips:
    'The description of the new version and can up to 1024 characters.',
  version_name_validator:
    'It is alpha-numeric plus underscores, and starts with a letter.',
  version_name_required_validator: 'name is required',
  version_desc_validator: 'Maximum input of 1024 characters allowed.',
  task_is_incomplete:
    'The preceding permission release task is incomplete, or there is an ongoing server start/stop task currently. Please try again later.',
  publish_confirm: 'Publish Confirm',
  confirm_changes_api_tips: 'Confirm changes to this API access permission?',
  no_re_submission_tips:
    'This application information is managed under the game hierarchy. It has already been submitted in another environment, so no re-submission is required. For modifications, please contact the InGame Team.',
  upgrade_version_tips:
    'This function is not currently supported in the current version. Please upgrade to version v1.10.0 or later.',
  task_being_published:
    'This task is currently being published, and modifications or discarding the release cannot be made temporarily.',
  publish_task_submit_success: 'Successfully submitted the publishing task.',
  currently_task_being_published:
    'There is currently a task being published. Please wait patiently.',
  service_not_deployed:
    'This service has not been deployed, so Client API control cannot be implemented.',
  event_sync_tips: 'Only involves the configuration of Custom Event',
  name_verification_failed: 'The format validation of the game name failed.',
  client_api_sync_tips:
    'Only the services activated in both environments are supported.',
  statistics_sync_tips: 'The Stats Event will be associated and synchronized.',
  type_not_support_live:
    'This type does not support the creation of a LIVE environment.',
  promo: 'Promo',
  matchmaking_apply_tips:
    'The services under Matchmaking cannot be activated individually.',
  gauth_permission_activated:
    'The Store service is enabled. You can start using it after applying for relevant access.',
  gauth_permission_expired:
    'The Store service is enabled. The relevant access has expired. Please apply for renewal.',
  gauth_permission_apply:
    'The Store service is enabled. The relevant access request is under review. Please wait patiently.',
  gauth_permission_apply_fail:
    'The Store service is enabled. The relevant access request has been rejected.',
  gauth_permission_frozen:
    'Your Store service permissions have been frozen due to long-term inactivity. Please contact platform support for assistance.',
  gauth_permission_denied:
    'Your permission request denied. Please revise the content and resubmit.',
  platform_access_application: 'Platform Access Application',
  platform_selection: 'Platform Selection',
  environment_details: 'Environment Details',
  creation_information: 'Creation Information',
  desc_information: 'Description',
  export_environment_configuration: 'Export Environment Configuration',
  env_export_tips:
    'Select environment and services to export, the system will generate an encrypted configuration package',
  select_export_service: 'Select Services to Export',
  no_services_exported: 'No services can be exported',
  verify_services_activated_desc:
    'Please verify that the corresponding services have been activated in the original environments.',
  import_environment_configuration: 'Import Environment Configuration',
  game_time_setting: 'Time Settings',
  weekly_definition: 'Weekly Definition',
  definition_st: 'st',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  time_next: '(next)',
  monthly_definition: 'Monthly Definition',
  next_monthly: '(next)',
  current_monthly: '',
  effective_time_zone: 'Effective Time Zone',
  effective_time_zone_desc:
    'This setting defines the time reference at the game level. Once effective, all time-related configurations for this game will follow this time zone and will not be affected by individual browser time zones.',
  system_settings: 'System Settings',
  game_selection: 'Game Selection',
  role_selection: 'Role Selection',
  role_default_one: 'External Platform Product & Development',
  role_default_two: 'Product Role',
  application_duration: 'Application Duration',
  application_reason: 'Application Reason',
  enter_application_reason: 'Please enter application reason',
  submit_application: 'Submit Application',
  one_click_renewal: 'One-click Renewal',
  game_default_one:
    'Daojucheng Support System (GMall / Beidou / Poseidon / Libra / Warehouse / Marketing / weLink)',
  game_default_two:
    'Interactive Entertainment AMS Platform – Marketing Campaign System / News & Advertising System / Gift & Item Warehouse',
  one_month: 'One Month',
  two_months: 'Two Months',
  three_months: 'Three Months',
  env_export_tips_desc:
    'The exported package will be encrypted and cannot be manually decompressed or modified. Version numbers and data integrity will be verified during import.',
  custom_data_tips:
    'The CustomData table only supports exporting the Now version.',
  create_export_task: 'Create Export Task',
  export_task_created_successfully: 'Export Task Created Successfully',
  export_download_tips:
    'System is exporting configuration in the background, will auto-download when complete.',
  export_close_tips:
    'You can close this window and continue with other operations.',
  go_to_view: 'Go to View',
  task_id: 'Task ID',
  import_upload_exceed_tips: 'The uploaded file cannot exceed 10M.',
  fail_to_upload: 'Fail to upload',
  uploading: 'Uploading...',
  file_check_tips: 'File verified, encryption signature valid',
  file_change: 'Change',
  package_support: 'Only supports encrypted .enc configuration package',
  drag_tips: 'Drag the file here or click',
  select_env_and_upload:
    'Select target environment and upload configuration package, the system will parse and import configurations.If the relevant service is not activated in the target environment, the configuration import for the corresponding service will be skipped.',
  upload_package: 'Upload Configuration Package',
  package_info: 'Package Information',
  export_time: 'Export Time',
  create_import_task: 'Create Import Task',
  import_task_created_successfully: 'Import Task Created Successfully',
  import_tips_one:
    'System is importing configuration to target environment in the background.',
  import_close_tips:
    'you can close this window and continue with other operations.',
  include_services: 'Included Services',
  version_error_tips:
    'Version mismatch! Target environment version ({{tarVersion}}) does not match package version ({{orgVersion}}). Import is not allowed.',
  platform_accessns_submit:
    'The application for platform accessns has been submitted.',
  platform_accessns_submit_renewal:
    'The renewal application for platform accessns has been submitted.',
  application_failed: 'Application failed',
  daily_definition: 'Daily Definition',
  calendar_day: 'Calendar Day',
  custom_day: 'Custom Day',
  cross_day: 'Cross-day',
  current_day: 'Current Day',
  day_next: '(next day)',
  current_day_empyt: '',
  calendar_Week: 'Calendar Week',
  custom_week: 'Custom Week',
  current_week: 'Current Week',
  cross_week: 'Cross-week',
  current_week_empyt: '',
  next_week: '(next)',
  calendar_month: 'Calendar Month',
  custom_month: 'Custom Month',
  cross_month: 'Cross-month',
  time_current_month: 'Current Month',
  time_month_next: '(next)',
  time_month_current: '',
};
